import { configureStore } from "@reduxjs/toolkit"
import authReducer from "./slices/authSlice"
import locationReducer from "./slices/locationSlice"
import adminStaffReducer from "./slices/adminStaffSlice"
import creditReducer from "./slices/creditSlice"
import userReducer from "./slices/userSlice"
import campaignReducer from "./slices/campaignSlice"
import transactionReducer from "./slices/transactionSlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
    locations: locationReducer,
    adminStaff: adminStaffReducer,
    credits: creditReducer,
    users: userReducer,
    campaigns: campaignReducer,
    transactions: transactionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
